import SegmentIcon from '@mui/icons-material/Segment';

import { SpeedDial } from '../../../components/SpeedDial';
import { PATH_SECTION_TEMPLATES_NEW_DEFAULT } from '../../../app/constants/paths.constant';

import { SectionTemplatesList } from './List';

export const SectionTemplatesTabPanel = () => (
  <>
    <SectionTemplatesList />
    <SpeedDial
      actions={[
        {
          id: 'createSectionTemplate',
          icon: <SegmentIcon />,
          name: 'Créer Modèle Section',
          to: PATH_SECTION_TEMPLATES_NEW_DEFAULT,
        },
      ]}
      title="Actions possibles sur les Modèles"
    />
  </>
);
